// Department filtering based on user email domain

// All available departments
export const ALL_DEPARTMENTS = [
  'ER',
  'ICU', 
  'NICU', 
  'Med-Surg', 
  'Pediatrics', 
  'Oncology', 
  'Cardiology', 
  'Neurology', 
  'PACU', 
  'Labor & Delivery', 
  'Psychiatry', 
  'Rehab', 
  "Women's Services (OB)"
];

// Domain-specific department restrictions
const DOMAIN_DEPARTMENT_MAP: Record<string, string[]> = {
  '@memorialhermann.org': ['ICU', 'Med-Surg', 'Rehab'],
  '@uhsinc.com': ['ER', 'Med-Surg', 'Psychiatry'],
};

/**
 * Get the list of departments available for a user based on their email domain.
 * If the user's domain has specific restrictions, only those departments are returned.
 * Otherwise, all departments are available.
 * 
 * @param userEmail - The user's email address
 * @returns Array of department names the user can access
 */
export function getAvailableDepartments(userEmail: string): string[] {
  if (!userEmail) {
    return ALL_DEPARTMENTS;
  }
  
  const emailLower = userEmail.toLowerCase();
  
  // Check if user's email matches any restricted domain
  for (const [domain, departments] of Object.entries(DOMAIN_DEPARTMENT_MAP)) {
    if (emailLower.endsWith(domain.toLowerCase())) {
      return departments;
    }
  }
  
  // No restrictions - return all departments
  return ALL_DEPARTMENTS;
}

/**
 * Check if a user has access to a specific department.
 * 
 * @param userEmail - The user's email address
 * @param department - The department to check access for
 * @returns true if the user can access the department
 */
export function canAccessDepartment(userEmail: string, department: string): boolean {
  const availableDepartments = getAvailableDepartments(userEmail);
  return availableDepartments.includes(department);
}
